import { Link } from 'react-router-dom';
import { LoaderBtn } from '../loading/Loader';
import { convertNumberPersianToEnglish } from '@helper/functions';

export default function SendOtpForm({ modalLoginHandler, formik, loading }) {
  // const SubmitHandler =(e)=>{
  //   e.preventDefault()
  //   SetCookie("alqqi" , "slaqqvik")
  // }

  return (
    <div className="w-full max-w-[600px] h-fit bg-white dark:bg-blackFont-900 z-[110] md:rounded-2xl rounded-none relative overflow-hidden">
      <div className="flex flex-col gap-12 items-center w-full relative py-12 px-2 md:px-20">
        {/* title */}
        <div className="flex flex-col items-center gap-8 z-10">
          <span className="text-xl md:text-2xl 2xl:text-3xl font-bold whitespace-nowrap text-text-hard dark:text-white">
            به پنل مشاورین املاک دابز خوش آمدید
          </span>
          <span className="text-sm md:text-[16px] font-[400] text-blackFont-700 dark:text-blackFont-300">
            برای ورود یا ثبت نام شماره موبایل خود را وارد کنید
          </span>
        </div>
        {/* input */}

        <div className="z-10 w-full">
          <form onSubmit={formik.handleSubmit} className="flex flex-col gap-10 w-full">
            <div className="relative">
              <label
                className={`w-full rounded-lg border-[1px] bg-white dark:bg-blackFont-800 ${
                  formik.errors.phone && formik.touched.phone
                    ? 'border-error'
                    : 'border-light-grey dark:border-blackFont-700 has-[:focus]:border-blackFont-900 dark:has-[:focus]:border-blackFont-400'
                } px-2 h-[48px] flex items-center justify-between z-10 overflow-hidden transition-all`}
              >
                <input
                  name="phone"
                  onChange={(event) => {
                    const raw = event.target.value.replace(/[^۰-۹0-9]/g, '');
                    const numericValue = convertNumberPersianToEnglish(raw);
                    formik.setFieldValue('phone', numericValue);
                  }}
                  onBlur={formik.handleBlur}
                  onFocus={(event) => {
                    const { value } = event.target;
                    event.target.setSelectionRange(value.length, value.length);
                  }}
                  value={formik.values.phone}
                  dir="ltr"
                  className="flex-1 h-full py-3 bg-transparent text-base text-text-hard dark:text-white px-2 placeholder:text-text-normal/70 dark:placeholder:text-blackFont-400"
                  placeholder="شماره موبایل"
                  type="text"
                  inputMode="numeric"
                  autoComplete="tel"
                />
                <span className="bg-blackFont-300 dark:bg-blackFont-600 h-[25px] w-[1px] flex"></span>
                <span className="w-fit px-2 text-blackFont-400 dark:text-blackFont-400">98+</span>
              </label>
              <span
                className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
                  formik.errors.phone && formik.touched.phone ? 'visible opacity-100' : 'invisible opacity-0'
                }`}
              >
                {formik.errors.phone}
              </span>
            </div>
            <div className="flex flex-col w-full gap-3 z-10">
              <div className="text-[12px] text-blackFont-400 dark:text-blackFont-400 flex items-start gap-1">
                <img className="w-[18px] opacity-70" src="/svg/attention.svg" alt="attention" />
                <div>
                  استفاده از دابز به معنی پذیرش{' '}
                  <Link target="_blank" to="/terms" className="font-bold text-primary underline">
                    قوانین و مقررات
                  </Link>{' '}
                  این سرویس است.
                </div>
              </div>

              <button
                type="submit"
                // disabled={formik.errors.phone || !formik.values.phone || loading}
                className="bg-primary disabled:cursor-not-allowed w-full h-[48px] flex items-center justify-center text-white rounded-lg transition-all"
              >
                {loading ? <LoaderBtn /> : 'تایید و دریافت کد'}
              </button>
            </div>
          </form>
        </div>

        {/*  */}
      </div>
    </div>
  );
}
